import { EnergyDirection } from "../types"

const convertDirectionArrayToString = (direction: EnergyDirection)=>{
    return `${direction[0]}-${direction[1]}`
}

export default convertDirectionArrayToString